import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useReportsQuery, reportTasksQueryOptions, businessQueryOptions } from '@/lib/query-options';
import { FileText } from 'lucide-react';
import { useAtomValue } from 'jotai';
import { useQuery } from '@tanstack/react-query';
import { organizationDataAtom } from '@/store';

export const Route = createFileRoute('/_authenticated/_layout/reports/')({
  component: ReportsIndexPage,
  staticData: {
    title: 'Reports',
    icon: FileText,
  },
});

function ReportsIndexPage() {
  const organizationData = useAtomValue(organizationDataAtom);
  const navigate = useNavigate();

  const { data: business } = useQuery({
    ...businessQueryOptions(organizationData?.id || 0),
    enabled: !!organizationData?.id,
  });

  const { data: reports = [], isLoading: reportsLoading } = useReportsQuery(
    organizationData?.id,
    1,
    20
  );

  const { data: taskStatus, isLoading: tasksLoading } = useQuery({
    ...reportTasksQueryOptions(business?.id ?? 0),
    enabled: !!business?.id,
  });

  const isLoading = reportsLoading || tasksLoading;

  useEffect(() => {
    // Wait for organization data to be loaded before navigating
    // This prevents a race condition where queries are disabled (isLoading=false)
    // but organization data hasn't been set yet, causing premature navigation to /reports/none
    if (!organizationData?.id) return;

    if (!isLoading) {
      let reportId = 'none';
      if (reports.length > 0) {
        reportId = String(reports[0].id);
      } else if (taskStatus?.has_in_progress) {
        reportId = 'generating';
      }
      navigate({
        to: '/reports/$reportId',
        params: { reportId },
        replace: true,
      });
    }
  }, [isLoading, reports, taskStatus, navigate, organizationData?.id]);

  return (
    <div className="flex items-center justify-center h-64">
      <div className="w-12 h-12 rounded-full border-4 border-gray-200 border-t-[#290BD9] animate-spin"></div>
    </div>
  );
}
